var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col text-center" },
          [
            _c(
              "b-link",
              { attrs: { href: "https://artenara.es/portal-ciudadano/" } },
              [
                _c("img", {
                  staticClass: "error-page_logo img-fluid",
                  attrs: {
                    src: require("../assets/ayto-artenara-logo.jpg"),
                    alt: "Logo del Ayuntamiento de Artenara"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "display-1 d-block" }, [_vm._v("404")]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-4 lead" }, [
              _vm._v("No hemos encontrado la página que busca.")
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              { attrs: { to: { name: "GenerateCertificate" } } },
              [_vm._v("Volver a inicio")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e367c50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e367c50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFoundPage.vue
// module id = null
// module chunks = 